// This is the JSON way to define React Router rules in a Rekit app.
// Learn more from: http://rekit.js.org/docs/routing.html

import {
  ControlAccount,
} from './';

export default {
  path: 'ca',
  name: 'Ca',
  childRoutes: [
    { path: 'control-account', name: 'Control account', component: ControlAccount, isIndex: true },
  ],
};



// WEBPACK FOOTER //
// ./src/features/ca/route.js